<script setup lang="ts">

const {
  autoAdvance,
  autoplay,
  setAutoAdvance,
  setAutoplay,
} = useUserPreferences();

const autoAdvanceActive = ref(unref(autoAdvance));
const autoplayActive = ref(unref(autoplay));

watch(autoplayActive, newVal => {
  setAutoplay(newVal);
});

watch(autoAdvanceActive, newVal => {
  setAutoAdvance(newVal);
});
</script>

<template>
  <div class="p-4">
    <div class="text-24 text-neutral-90 font-bold mb-4">
      Playback preferences
    </div>

    <div class="flex flex-col gap-2">
      <label class="flex items-center justify-between">
        <div class="description">
          Autoplay videos
        </div>

        <div class="input">
          <InputSwitch v-model="autoplayActive" />
        </div>
      </label>

      <label class="flex items-center justify-between">
        <div class="description">
          Auto advance lesson
        </div>

        <div class="input">
          <InputSwitch v-model="autoAdvanceActive" />
        </div>
      </label>
    </div>
  </div>
</template>
